import { getStore } from './store';

export default abstract class IService {
  protected get state() {
    return getStore().getState();
  }
}
